export function createObjectURL(data: any) {
  const windowUrl = window.URL || window.webkitURL

  return windowUrl.createObjectURL(new Blob([data]))
}

export function revokeObjectURL(url: string) {
  const windowUrl = window.URL || window.webkitURL

  return windowUrl.revokeObjectURL(url)
}
